import $ from 'jquery';
import 'slick-carousel';
import debounce from 'lodash/debounce';

$(document).ready(() => {
  initCarousel();
  // you need this to reslick the carousel when moving between desktop and mobile
  $(window).resize(debounce(initCarousel, 50));
});

function initCarousel() {
  const $carousel = $('.js-oneplus-product-carousel');

  if ($carousel.length && !$carousel.hasClass('slick-initialized')) {
    $($carousel).slick({
      dots: false,
      arrows: true,
      pauseOnHover: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 1000,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  const $tripleCardCarousel = $('.js-oneplus-triple-cards-carousel');
  if ($tripleCardCarousel.length && !$tripleCardCarousel.hasClass('slick-initialized')) {
    $($tripleCardCarousel).slick({
      mobileFirst: true,
      dots: false,
      arrows: false,
      pauseOnHover: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 1000,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      centerMode: true,
      responsive: [
        {
          breakpoint: 769,
          settings: 'unslick', // This will unslick itself on mobile
        },
      ],
    });
  }
  const $chargerItemCarousel = $('.js-charger-carousel');
  if ($chargerItemCarousel.length > 0 && !$chargerItemCarousel.hasClass('slick-initialized')) {
    $($chargerItemCarousel).slick({
      mobileFirst: true,
      dots: false,
      arrows: false,
      speed: 1000,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      centerMode: true,
      // slide: '.js-slide',
      responsive: [
        {
          breakpoint: 769,
          settings: 'unslick', // This will unslick itself on mobile
        },
      ],
    });
  }
}
